export default __webpack_public_path__ + "static/media/nna.31205653.jpeg";